import React from 'react';
import styled from 'styled-components';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../theme/ThemeProvider';

const HeaderContainer = styled.header`
  padding: 1rem 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: ${({ theme }) => theme.bgSecondary};
  border-bottom: 1px solid ${({ theme }) => theme.border};

  @media (max-width: 480px) {
    padding: 0.75rem 0;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LogoIcon = styled.div`
  width: 28px;
  height: 28px;
  margin-right: 10px;
  position: relative;
  
  &::before, &::after {
    content: '';
    position: absolute;
    background-color: ${({ theme }) => theme.accent};
  }
  
  &::before {
    width: 100%;
    height: 3px;
    top: 50%;
    transform: translateY(-50%);
  }
  
  &::after {
    width: 3px;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Logo = styled.h1`
  font-size: 1.6rem;
  font-weight: 800;
  color: ${({ theme }) => theme.accent};
  letter-spacing: -0.5px;
  position: relative;
  text-transform: uppercase;
  
  span {
    font-weight: 300;
    opacity: 0.9;
  }

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }

  @media (max-width: 480px) {
    font-size: 1.2rem;
  }
`;

const ThemeToggle = styled.button`
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.text};
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.hover};
  }
`;

const Header = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <HeaderContainer>
      <div className="container">
        <HeaderContent>
          <LogoWrapper>
            <LogoIcon />
            <Logo>Sähkö<span>llä</span></Logo>
          </LogoWrapper>
          <ThemeToggle onClick={toggleTheme} aria-label="Vaihda teemaa">
            {theme === 'light' ? <FiMoon size={24} /> : <FiSun size={24} />}
          </ThemeToggle>
        </HeaderContent>
      </div>
    </HeaderContainer>
  );
};

export default Header;
